<template>
  <b-form-group
    label="İşlem Tarihi"
    label-for="sdate"
  >
    <b-input-group>
      <b-form-datepicker
        id="sdate"
        v-model="filterParams.sdate"
        v-bind="{labelNoDateSelected: 'Başlangıç Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
        locale="tr"
        start-weekday="1"
        class="border-right-0"
      />
      <b-input-group-addon is-text>
        -
      </b-input-group-addon>
      <b-form-datepicker
        id="edate"
        v-model="filterParams.edate"
        v-bind="{labelNoDateSelected: 'Bitiş Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
        locale="tr"
        start-weekday="1"
      />
      <b-input-group-append v-if="filterParams.sdate || filterParams.edate">
        <b-button
          variant="warning"
          @click="clearDates"
        >
          <FeatherIcon
            icon="XCircleIcon"
          />
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>
<script>
import {
  BFormDatepicker, BFormGroup, BInputGroup, BButton, BInputGroupAddon, BInputGroupAppend,
} from 'bootstrap-vue'

export default {
  name: 'DonateDates',
  components: {
    BInputGroup,
    BFormGroup,
    BFormDatepicker,
    BButton,
    BInputGroupAppend,
    BInputGroupAddon,
  },
  computed: {
    filterParams() {
      return this.$store.getters['accountActivities/filterParams']
    },
  },
  methods: {
    clearDates() {
      this.filterParams.sdate = null
      this.filterParams.edate = null
    },
  },
}
</script>
